export enum TrackingStep {
    ContactInfo = 'ContactInfo',
    About = 'About',
    Sbl = 'Sbl',
    Kyc = 'Kyc',
    SummaryKyc = 'SummaryKyc',
    SendApplication = 'SendApplication',
    ApplicationApproved = 'CreditCardApplicationApproved',
    ApplicationControl = 'CreditCardApplicationControl',
    ApplicationRejected = 'CreditCardApplicationRejected',
}

export const trackEvent = (trackingStep: TrackingStep) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'virtual-page-view',
        virtual_path: trackingStep,
        app_namespace: 'kredittbank.kredittkort.soknad.web',
    });
};
